import React, { Component } from 'react';
import { Button } from '@trevor/ui-components';
import flex from '../../css/module/flex.css';

export const MODAL_ID = 'modal-id';

const stopPropagation = (e) => {
  if (e.target.dataset.stopPropagation) e.stopPropagation();
};

class PopupModal extends Component {
  componentDidMount() {
    const { modalHidden } = this.props;
    $(`#${MODAL_ID}`)
      .on('hidden.bs.modal', () => {
        modalHidden(); // need to trigger this here, as there are multiple ways the modal can be closed (such as user clicking X in top right, or user clicking outside the modal)
      })
      .on('click', stopPropagation);
  }

  render() {
    const { title, subTitle, children, saveButton, wide, isSelectModal } =
      this.props;

    const style = {};

    if (isSelectModal) {
      style.maxHeight = '90vh';
      style.height = '90vh';
      style.padding = '0px 30px';
    }

    // important: modal is wrapped in a div as we don't want it to be root element (bootstrap adds style='display:none' when hiding modal, and this isn't removed in fullScreen mode above otherwise)
    return (
      <div>
        <div id={MODAL_ID} className="modal fade" data-stop-propagation>
          <div className={`modal-dialog modal-lg ${wide ? 'wide' : ''}`}>
            <div className="modal-content" style={style}>
              {isSelectModal ? (
                <div className={`${flex.column} h-100`}>
                  <div
                    className={`${flex.header} w-100 ${flex.justifyContentBetween} ${flex.alignItemsCenter}`}
                  >
                    <div>
                      <h4 className="modal-title">
                        <b>{title}</b>
                      </h4>
                    </div>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                  </div>
                  <div className={flex.content} style={{ overflow: 'hidden' }}>
                    {children}
                  </div>
                  <div
                    className={`${flex.footer} ${flex.justifyContentEnd} ${flex.alignItemsCenter}`}
                  >
                    <Button
                      variant="secondary"
                      type="button"
                      className="margin-right-10"
                      data-bs-dismiss="modal"
                    >
                      {saveButton ? 'Cancel' : 'Close'}
                    </Button>
                    {saveButton}
                  </div>
                </div>
              ) : (
                <div>
                  <div className="modal-header">
                    <h4 className="modal-title">{title}</h4>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                  </div>

                  <div className="modal-body">
                    {subTitle && <p>{subTitle}</p>}
                    {children}
                  </div>
                  <div
                    className={`modal-footer ${flex.row} ${flex.justifyContentEnd}`}
                  >
                    <div
                      id="dependant-queries-go-back-button-container"
                      style={{ marginRight: 'auto' }}
                    />
                    <Button
                      variant="secondary"
                      className="margin-right-10"
                      data-bs-dismiss="modal"
                      data-stop-propagation
                      onClick={stopPropagation}
                    >
                      {saveButton ? 'Cancel' : 'Close'}
                    </Button>
                    {saveButton}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PopupModal;
